// Marketplace categories - GET /v1/marketplace/categories
const ns = "MARKETPLACE_CATEGORIES";
export const REQUEST  = ns + '_REQUEST';
export const RESPONSE = ns + '_RESPONSE';
export const FAILURE  = ns + '_FAILURE';

export const fetchRequest = () => ({ type: REQUEST });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
